// removed by extract-text-webpack-plugin
module.exports = {"intro":"NhliB6_RwIL75_hc7AGCt","title":"_3MDyoy55KvrzodPU6nPKvZ","introSection":"_2KFedWhjUL0f3SnSmZ0b-P","header":"_231EvZuRnaKugVQ180F9o0","introTable":"_1ErzURCB3D7qM3y0y1ABmc","sectionTitle":"_1nFECj1bM390tL0B5wXz2N","introLeft":"_1cGGr1lN1cFFsE2pe99TOb","introRightLogo":"_3vmd8W3JACa7o_PxXTyuKe","headerTable":"_3-aZa49_eQL9RZn3YEaC_K"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Policy/IntroMobile.scss
// module id = 233
// module chunks = 0